import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import '../typography/Text.js';
import '../typography/Display.js';
import '../typography/Heading.js';
import '../typography/Label.js';
import { Paragraph } from '../typography/Paragraph.js';
import React__default from 'react';
import styled from 'styled-components';
import '../media/Img.js';
import { Icon } from '../media/Icon.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import { Input } from './Input.js';
import { InputRightElement } from './InputElement.js';
import { InputGroup } from './InputGroup.js';
var PASSWORD_LOWERCASE_REGEX = /[a-z]/;
var PASSWORD_UPPERCASE_REGEX = /[A-Z]/;
var PASSWORD_NUMBER_REGEX = /[0-9]/;
var PASSWORD_SYMBOL_REGEX = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
var PASSWORD_MIN_LENGTH_REGEX = /.{8,}/;
var defaultTranslation = {
  length: "Minimum of 8 characters,",
  lowercase: "at least one lowercase letter,",
  uppercase: "at least one uppercase letter,",
  number: "at least one number,",
  symbol: "at least one symbol",
  safe: "Strong password"
};
function getPasswordStrenght(password) {
  var points = 0;
  var strength = {
    length: false,
    lowercase: false,
    uppercase: false,
    number: false,
    symbol: false
  };
  if (password === null || password === void 0 ? void 0 : password.match(PASSWORD_MIN_LENGTH_REGEX)) {
    strength.length = true;
    points += 20;
  }
  if (password === null || password === void 0 ? void 0 : password.match(PASSWORD_LOWERCASE_REGEX)) {
    strength.lowercase = true;
    points += 20;
  }
  if (password === null || password === void 0 ? void 0 : password.match(PASSWORD_UPPERCASE_REGEX)) {
    strength.uppercase = true;
    points += 20;
  }
  if (password === null || password === void 0 ? void 0 : password.match(PASSWORD_NUMBER_REGEX)) {
    strength.number = true;
    points += 20;
  }
  if (password === null || password === void 0 ? void 0 : password.match(PASSWORD_SYMBOL_REGEX)) {
    strength.symbol = true;
    points += 20;
  }
  return {
    points: points,
    strength: strength
  };
}
var CompletedCheck = function CompletedCheck(_a) {
  var strength = _a.strength,
    isInvalid = _a.isInvalid;
  var isComplete = function isComplete() {
    var points = strength.points;
    return points === 100 && !isInvalid;
  };
  return React__default.createElement(Box, {
    marginRight: "14px",
    opacity: isComplete() ? "1" : "0",
    transition: "all 200ms"
  }, React__default.createElement(Icon, {
    fontSize: "24px",
    color: "green.300",
    icon: "done"
  }));
};
var StrengthTextContainer = styled(Box)(function (_a) {
  var isVisible = _a.isVisible;
  return css({
    maxHeight: isVisible ? "84px" : "0",
    overflow: "hidden",
    width: "100%",
    paddingTop: isVisible ? "8px" : "0",
    transition: "all 200ms"
  });
});
var StrengthPhrase = styled(Paragraph)(function (_a) {
  var isActive = _a.isActive,
    isInvalid = _a.isInvalid,
    isSafe = _a.isSafe;
  var textColor = "textPrimary";
  if (isInvalid) textColor = "red.300";
  if (isActive) textColor = "grey.2";
  if (isSafe) textColor = "green.300";
  return css({
    color: textColor,
    display: "inline",
    transition: "all 250ms",
    lineHeight: "18px"
  });
});
StrengthPhrase.defaultProps = {
  size: "sm"
};
var StrengthText = function StrengthText(_a) {
  var translation = _a.translation,
    isFocused = _a.isFocused,
    isInvalid = _a.isInvalid,
    _b = _a.strength,
    strength = _b.strength,
    points = _b.points;
  return React__default.createElement(StrengthTextContainer, {
    isVisible: isFocused || isInvalid
  }, points === 100 ? React__default.createElement(StrengthPhrase, {
    isActive: true,
    isSafe: true
  }, translation.safe) : React__default.createElement(React__default.Fragment, null, React__default.createElement(StrengthPhrase, {
    isActive: strength.length,
    isInvalid: isInvalid
  }, translation.length), " ", React__default.createElement(StrengthPhrase, {
    isActive: strength.lowercase,
    isInvalid: isInvalid
  }, translation.lowercase), " ", React__default.createElement(StrengthPhrase, {
    isActive: strength.uppercase,
    isInvalid: isInvalid
  }, translation.uppercase), " ", React__default.createElement(StrengthPhrase, {
    isActive: strength.number,
    isInvalid: isInvalid
  }, translation.number), " ", React__default.createElement(StrengthPhrase, {
    isActive: strength.symbol,
    isInvalid: isInvalid
  }, translation.symbol)));
};
var PasswordInput = React__default.forwardRef(function (_a, ref) {
  var onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    onChange = _a.onChange,
    hasCompletedCheck = _a.hasCompletedCheck,
    hasStrengthText = _a.hasStrengthText,
    _b = _a.translation,
    translation = _b === void 0 ? defaultTranslation : _b,
    rest = __rest(_a, ["onFocus", "onBlur", "onChange", "hasCompletedCheck", "hasStrengthText", "translation"]);
  var _c = React__default.useState(false),
    isVisible = _c[0],
    setVisible = _c[1];
  var _d = React__default.useState(false),
    isFocused = _d[0],
    setIsFocused = _d[1];
  var isInvalid = rest.isInvalid;
  var _e = React__default.useState(undefined),
    currentValue = _e[0],
    setCurrentValue = _e[1];
  var hasValue = ((currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) || 0) > 0;
  var toggleVisible = function toggleVisible() {
    return setVisible(!isVisible);
  };
  var strength = getPasswordStrenght(currentValue);
  var handleChange = function handleChange(e) {
    setCurrentValue(e.target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  var handleFocus = function handleFocus(e) {
    setIsFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  };
  var handleBlur = function handleBlur(e) {
    setIsFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  };
  var calcBorderColor = function calcBorderColor() {
    if (!isInvalid && isFocused && strength.points === 100) return "green.300";
    return undefined;
  };
  return React__default.createElement(Box, null, React__default.createElement(InputGroup, null, React__default.createElement(Input, __assign({}, rest, {
    ref: ref,
    type: isVisible ? "text" : "password",
    borderColor: calcBorderColor(),
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  })), (hasValue || isFocused) && React__default.createElement(InputRightElement, null, hasCompletedCheck && React__default.createElement(CompletedCheck, {
    strength: strength,
    isInvalid: isInvalid
  }), React__default.createElement(Icon, {
    icon: isVisible ? "visible" : "invisible",
    color: "grey.2",
    onClick: toggleVisible,
    fontSize: "22px"
  }))), hasStrengthText && React__default.createElement(StrengthText, {
    translation: translation,
    isFocused: isFocused,
    isInvalid: isInvalid,
    strength: strength
  }));
});
export { PASSWORD_LOWERCASE_REGEX, PASSWORD_MIN_LENGTH_REGEX, PASSWORD_NUMBER_REGEX, PASSWORD_SYMBOL_REGEX, PASSWORD_UPPERCASE_REGEX, PasswordInput, getPasswordStrenght };